module.exports = __webpack_public_path__ + "res/35-img_game_bg.4f0ee2ecde3a452ec9fa67e77aac0033.png";